function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconApp = function SvgIconApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M5.5 3.5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-17zm.5 15h12M6 5h12"
  }));
};
export default SvgIconApp;